module.exports = __webpack_public_path__ + "img/744.c878ad65.jpg";